<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "FilialContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
	}),
	methods: {
		montarMenu() {
			let m = [];

			if (this.permissao("filial_listar")) {
				m.push({
					titulo: "Filiais",
					titulo_app: "Filiais",
					icon: "mdi-store-outline",
					to: "/filial",
					tooltip: "Lista de filiais da empresa",
				});
			}

			if (this.permissao("filial_definir_meta")) {
				m.push({
					titulo: "Definir Metas",
					titulo_app: "Definir Metas",
					icon: "mdi-speedometer",
					to: "/filial/metas",
					tooltip:
						"Tela de lançamento de metas mensais por vendedor e filial",
				});
			}

      if (this.permissao("filial_acompanhamento_metas_vendedores")) {
        m.push({
          titulo: "Acompanhamento de metas",
          titulo_app: "Metas",
          icon: "mdi-bullseye-arrow",
          to: "/filial/acompanhamento",
          tooltip:
              "Tela de acompanhamento de metas por vendedor",
        });
      }

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>